import { TableSortLabel } from '@mui/material';
import useSortLabelStyles from '../styles/useSortLabelStyles';

export type sortDirection = 'asc' | 'desc' | undefined;

interface ISortLabelProps {
  label: string;
  orderBy: sortDirection;
  setOrderBy: (sortDirection: sortDirection) => void;
  onChange?: () => void;
}

function SortLabel(props: ISortLabelProps) {
  const classes = useSortLabelStyles();
  const { label, orderBy, setOrderBy, onChange } = props;

  /**
   * Used in the onClick handler to determine and return the next logical orderBy state for the sort label
   * @returns next order by state
   */
  const getNextSortDirection = () => {
    if (orderBy === 'asc') {
      return 'desc';
    }

    return 'asc';
  };

  return (
    <TableSortLabel
      className={classes.root}
      active={Boolean(orderBy)}
      direction={orderBy}
      onClick={() => {
        setOrderBy(getNextSortDirection());
        onChange && onChange();
      }}
    >
      {label}
    </TableSortLabel>
  );
}

export default SortLabel;
